import React from "react";
import { Link } from "react-router-dom";
import "./Sitemap.css";
import IkoroduLogo from "../assets/OnboardingCards/Ikorodu-Dating-Logo.svg";
import { useNavigate } from "react-router-dom";
import ChatAssistance from "../assets/OnboardingCards/HelpLoverr.svg";
import Verify from "../assets/verified.svg";
import BackArrow from "../assets/goBackarrow.svg";

const Sitemap = () => {
  const navigate = useNavigate();
  return (
    <div className="sitemap-container">
      <div style={{ paddingTop: 16 }} className="onboardingBackBTN">
        <button onClick={() => navigate(-1)}>
          <img src={BackArrow} alt="back button" />
        </button>
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            color: "#e91e63",
            alignItems: "center",
            display: "flex",
            gap: 6,
          }}
        >
          Sitemap <img style={{ width: 15 }} src={Verify} alt="" />
        </p>
        <button onClick={() => navigate("/help")}>
          <img src={ChatAssistance} alt="back button" />
        </button>
      </div>
   
      <ul className="sitemap-list">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about">About Us</Link>
        </li>
        <li>
          <Link to="/terms">Terms and Conditions</Link>
        </li>
        <li>
          <Link to="/disclaimer">Disclaimer</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy Policy</Link>
        </li>
        <li>
          <Link to="/help">Help Page</Link>
        </li>
        <li>
          <Link to="/chats">Chats </Link>
        </li>
        <li>
          <Link to="/user-details">User Details</Link>
        </li>
        <li>
          <Link to="/profile">View your Profile</Link>
        </li>
        <li>
          <Link to="/match">See your Match</Link>
        </li>
        <li>
          <Link to="/whatsapp">WhatsApp Us</Link>
        </li>
        <li>
          <Link to="/match">Contact Us</Link>
        </li>
        <li>
          <Link to="/login">Login your account</Link>
        </li>
        <li>
          <Link to="/signup">Sign Up</Link>
        </li>
        <li>
          <Link to="/verification">Submit Document</Link>
        </li>
        <li>
          <Link to="/sexual-orientation-selection">Choose</Link>
        </li>
        <li>
          <Link to="/awaiting-approval">Awaiting Approval</Link>
        </li>
      </ul>
    </div>
  );
};

export default Sitemap;
